import React from "react"
import { Dropdown } from "./dropdown"
import CurveBSm from "./icons/curve-b-sm"
import CurveRound from "./icons/curve-round"
import CurveTLg from "./icons/curve-t-lg"
import CurveTMd from "./icons/curve-t-md"
import StyledImage from "./styled-image"

export default function Hero({ title, props }) {
  const image = props?.image
  const imageOptions = props?.imageOptions
  const imageFocus = imageOptions?.imageFocus
  const dropdown = props?.dropdown
  return (
    <header
      className={`${image ? "-mb-4" : "bg-gradient-to-r from-blue to-magenta pt-6"
        } relative`}
    >
      {image ? (
        <div className="md:grid md:grid-cols-5 md:grid-flow-col-dense relative">
          <div className="px-8 pb-4 md:pb-16 md:pl-4 p-8 bg-blue md:col-span-2 md:col-start-4 relative flex flex-row items-center ">
            <CurveBSm className="block md:hidden absolute z-10 translate-y-full bottom-[1px] w-full inset-x-0 h-auto text-blue" />
            <div className="md:max-w-md">
              {title ? (
                <h1 className={`h2 leading-normal text-white`}>{title}</h1>
              ) : null}
              {dropdown?.items ? (
                <div
                  data-sal="slide-up"
                  data-sal-delay="300"
                  data-sal-easing="ease"
                  data-sal-duration="500"
                  className="mt-6 relative"
                >
                  {dropdown.items && (
                    <ol
                      className="list-decimal"
                      data-sal="slide-down"
                      data-sal-easing="ease"
                    >
                      <Dropdown
                        options={dropdown.items}
                        theme="light"
                        placeholder={dropdown.placeholder}
                      />
                    </ol>
                  )}
                </div>
              ) : null}
            </div>
            <CurveRound className="hidden md:block text-blue h-full w-auto absolute -translate-x-full left-[2px] z-10" />
          </div>
          <div className="md:col-span-3 h-1/3-screen sm:h-1/2-screen md:h-auto md:min-h-1/2-screen">
            <StyledImage
              image={image}
              objectFit="cover"
              objectPosition={imageFocus}
              className={`w-full h-full`}
            />
          </div>
          <CurveTLg className="  text-white w-full absolute bottom-[-2px] z-10 opacity-50" />
          <CurveTMd className="  text-white w-full absolute bottom-[-2px] z-10" />
        </div>
      ) : (
        <div className={`container pt-9 pb-10 relative ${image ? "" : ""}`}>
          {title ? <h1 className={`text-white`}>{title}</h1> : null}
        </div>
      )}
    </header>
  )
}
